import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { IGetNodeForModel } from "../../ts/interfaces";

export const GET_NODE = gql`
    query GetModelSchema {
        modelSchema
    }
`;

export const GET_NODE_FOR_MODEL = gql`
    query GetModelSchemaForModel($model: String) {
        modelSchema(model:$model)
    }
`;

export const GET_UI_SCHEMA = gql`
    query GetUiSchema {
        uiSchema
    }
`;

const useGetModelSchema = () => {
    return useQuery(GET_NODE, {
        notifyOnNetworkStatusChange: false,
        fetchPolicy: 'cache-and-network',
    });
};

const useGetModelSchemaForModel = ({ variables }: IGetNodeForModel) => {
    return useQuery(GET_NODE_FOR_MODEL, {
        variables,
        notifyOnNetworkStatusChange: false,
        fetchPolicy: 'cache-and-network',
    });
};

const useGetUiSchema = () => {
    return useQuery(GET_UI_SCHEMA, {
        notifyOnNetworkStatusChange: false,
        fetchPolicy: 'cache-and-network',
    });
};

export { useGetModelSchema, useGetModelSchemaForModel, useGetUiSchema };
